import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "toastr/build/toastr.min.css";
import { getSetting } from "../../api/api";
import { UserStore } from "../../store/userStore";

const Profile = (props) => {
  const role = UserStore.useState((s) => s.user);
  const [details, setDetails] = useState("");

  useEffect(() => {
    const appDetails = async () => {
      /* eslint-disable no-unused-vars */
      const result = await getSetting().then(
        (result) => {
          setDetails(result.data);
        },
        (error) => {
          const obj = {
            status: error.response.data.error.status,
            message: error.response.data.error.message,
          };
        }
      );
      /* eslint-disable no-unused-vars */
    };

    appDetails();
  }, [role]);

  return (
    <section className="content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <div className="card-header">
                <h3 className="card-title">Profile</h3>
              </div>
              {/* /.card-header */}
              <div className="card-body ">
                {/* <form> */}
                <div className="row">
                  {/* <div className="col-sm-6"> */}
                  <div className="col-sm-12" style={{ top: 20 }}>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label>User Name</label>
                          <input
                            type="text"
                            name="primaryBackgroundColor"
                            className="form-control inside-form"
                            defaultValue={role.name}
                            autoComplete="off"
                            disabled
                          />
                        </div>
                      </div>
                      <div className="col-sm-6">
                        {/* text input */}
                        <div className="form-group">
                          <label>User Role</label>
                          <input
                            type="text"
                            name="secondaryBackgroundColor"
                            className="form-control inside-form"
                            defaultValue={
                              role.superAdmin === true
                                ? "Super Admin"
                                : role.admin === true
                                  ? "Admin"
                                  : role.editor === true
                                    ? "Editor"
                                    : "Reader"
                            }
                            autoComplete="off"
                            disabled
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label>App Name</label>
                          <input
                            type="text"
                            name="primaryTextColor"
                            className="form-control inside-form"
                            defaultValue={details.title}
                            autoComplete="off"
                            disabled
                          />
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <label>App Id</label>
                          <input
                            type="text"
                            name="primaryTextColor"
                            className="form-control inside-form"
                            defaultValue={details.application}
                            autoComplete="off"
                            disabled
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label>Mail Id</label>
                          <input
                            type="text"
                            name="primaryTextColor"
                            className="form-control inside-form"
                            defaultValue={role.email}
                            autoComplete="off"
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-12">
                    <div
                      className="btn-group btn-group-md float-right"
                      role="group"
                    >
                      <Link
                        to={{
                          pathname: "/passwordchange",
                          state: { id: role._id },
                        }}
                      >
                        <button
                          type="button"
                          className="btn btn-light"
                          style={{ width: "200px", marginRight: "6px" }}
                        >
                          Change Password
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
                {/* </form> */}
              </div>
              {/* /.card-body */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Profile;
